module.exports = __webpack_public_path__ + "static/media/revenues.7b9aa73e.svg";